import React from 'react';
import { FormModal } from 'components/common';
import { Col, Form, Row, Select } from 'components';
import { AdminsSelect } from 'components/common/adminsSelect';
import { useAssignmentEdit } from './useAssignmentEdit';

export interface IAssignmentUpdate {
  onCancel: () => void;
  open: boolean;
}

export const AssignmentEditModal = React.memo((props: IAssignmentUpdate) => {
  const { onCancel: onCancelModal, open } = props;
  const { userData, form, isLoadingUpdate, onFinish, onCancel, handleManagerChange } = useAssignmentEdit({
    onCancelModal,
    open,
  });

  const roleMapping = {
    salesManager: 'Sales Manager',
    salesManagerAssistant: 'Sales Manager Assistant',
    purchaseManager: 'Purchase Manager',
    purchaseManagerAssistant: 'Purchase Manager Assistant',
  };

  return (
    <FormModal
      form={form}
      title={'Update Assignments'}
      okText={'Save'}
      open={open}
      isLoading={isLoadingUpdate}
      onCancel={onCancel}
      onSubmit={onFinish}
    >
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Form.Item label={roleMapping.purchaseManager} name={'purchaseManagerId'}>
            <AdminsSelect
              size={'large'}
              onSelect={(value) => handleManagerChange(value, 'purchaseManagerAssistantId')}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            shouldUpdate={(prevValues: any, currentValues: any) =>
              prevValues.purchaseManagerId !== currentValues.purchaseManagerId
            }
          >
            {({ getFieldValue }) => {
              return (
                <Form.Item label={roleMapping.purchaseManagerAssistant} name={'purchaseManagerAssistantId'}>
                  <Select
                    size={'large'}
                    options={userData.map((i: { value: string; label: string }) => ({
                      ...i,
                      disabled: getFieldValue('purchaseManagerId') === i.value,
                    }))}
                    disabled={!getFieldValue('purchaseManagerId')}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label={roleMapping.salesManager} name={'salesManagerId'}>
            <AdminsSelect size={'large'} onSelect={(value) => handleManagerChange(value, 'salesManagerAssistantId')} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            shouldUpdate={(prevValues: any, currentValues: any) =>
              prevValues.salesManagerId !== currentValues.salesManagerId
            }
          >
            {({ getFieldValue }) => {
              return (
                <Form.Item label={roleMapping.salesManagerAssistant} name={'salesManagerAssistantId'}>
                  <Select
                    size={'large'}
                    options={userData.map((i: { value: string; label: string }) => ({
                      ...i,
                      disabled: getFieldValue('salesManagerId') === i.value,
                    }))}
                    disabled={!getFieldValue('salesManagerId')}
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>
      </Row>
    </FormModal>
  );
});
